import { render } from "./SecondaryTotal.vue?vue&type=template&id=49835722&scoped=true"
import script from "./SecondaryTotal.vue?vue&type=script&lang=js"
export * from "./SecondaryTotal.vue?vue&type=script&lang=js"

import "./SecondaryTotal.vue?vue&type=style&index=0&id=49835722&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49835722"]])

export default __exports__